import { TranslateService } from '@ngx-translate/core';
import { Diagnostic, IoCContainer } from '@lmnop/web-core';
import { IAngularTranslation } from './angular-translation.interface';
import { AngularCoreIoCKeys } from 'angular-core-src';

export class AngularTranslation implements IAngularTranslation {
    private translateService: TranslateService;

    public getMessage(messageName: string, substitutions?: any): string {
        //keep it for debugging purpose
        //Diagnostic.debug('AngularTranslation - getMessage - ' + messageName);

        let translatedText: string = this.translateService.instant(messageName, substitutions);
        //keep it for debugging purpose
        //Diagnostic.debug('AngularTranslation - getMessage - messageName: ' + messageName + ' translatedText: ' + translatedText);
        return translatedText;
    }

    public async waitUntilInitialized(): Promise<any> {
        this.translateService = IoCContainer.getThirdPartyInstance(AngularCoreIoCKeys.AngularTranslateService);

        let i = 0;
        while (!this.isInitialized()) {
            await Diagnostic.sleepAsync(0.1);
            i++;

            if (i === 100) {
                break;
            }
        }
    }

    public isInitialized(): boolean {
        return !this.translateService['pending'];
    }

    public getCurrentLanguage(): string {
        return this.translateService.currentLang;
    }
}
